module.exports = __webpack_public_path__ + "static/typography-ded3218bd5caa3d13814016615f4ed01.mp4";